import React from "react";
import JobDetail from "../components/Jobs/JobDetail";
import NotFoundPage from "./NotFoundPage";

const JobDetailPage = () => {
  const isContractorLoggedIn = sessionStorage.getItem("Contractor-vUniqueCode");
  return <> {isContractorLoggedIn ? <JobDetail /> : <NotFoundPage />}</>;
};

export default JobDetailPage;
